
<template>
  <div class="relative mx-auto bg-gray-300 layout-idp">
    <section class="section__one" :class="getMinHeightSectionCls">
      <div class="container-idp">
        <div class="idp-content">
          <iframe :class="getIsLoginMigrateCheckIdp ? 'max-800:!min-h-[390px]' : '' " :src="idpLoginSectionOneUrl" width="100%" height="100%" frameborder="0" scrolling="no" />
        </div>
      </div>
      <div class="container-sso">
        <div class="sso-content">
          <MobileHeader />

          <main class="flex-auto flex-shrink-0 flex justify-center w-full my-0 mx-auto pb-4">
            <div class="form-card form-card-sm bg-white border border-gray-100 w-full">
              <router-view></router-view>
            </div>
          </main>

          <LangSelector />
        </div>
      </div>
    </section>
    <section class="section__two" v-if="!!idpLoginSectionTwoUrl">
      <iframe :src="idpLoginSectionTwoUrl" width="100%" height="100%" frameborder="0" scrolling="no" />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileHeader from '@/components/layout/MobileHeader';
import LangSelector from '@/components/LangSelector.vue';

export default {
  name: 'IdpLayout',
  components: {
    MobileHeader,
    LangSelector,
  },
  computed: {
    ...mapState(['loginFrom', 'userLang']),
    getMinHeightSectionCls() {
      if(this.getIsLoginMigrateCheckIdp) {
        return "min-h-[auto]"
      }
      return "min-h-screen"
    },
    getIframeLang() {
      let lang = this.userLang;
      if (lang === 'ja-JP') lang = 'ja';
      return lang
    },
    getIsLoginMigrateCheckIdp() {
      return this.loginFrom === 'login_migrate_check_idp'
    },
    idpLoginSectionOneUrl() {
      let type = 'login';
      if (this.loginFrom === 'login_trial_idp') type = 'trial';
      if (this.getIsLoginMigrateCheckIdp) type = 'migrateCheck';
      
      return `${process.env.IDP_LOGIN_URL}/${type}/${this.getIframeLang}/index.html`;
    },
    idpLoginSectionTwoUrl() {
      if (this.getIsLoginMigrateCheckIdp){
        return `${process.env.IDP_LOGIN_URL}/migrateCheck/${this.getIframeLang}/learnMore.html`;
      }
      return ""
    },
  },
}
</script>

<style lang="sass" scoped>
.form-card
  max-width: 480px
  padding: 40px
  border-radius: 16px

  @media (max-width: 720px)
    padding: 24px

.form-card-sm
  width: 320px
  padding: 24px
  margin: 0

  @media (max-width: 800px)
    width: 100%
    max-width: 480px

.section
  height: 100%
  
  @media (max-width: 800px)
    height: auto

  &__one
    display: flex
    @media (max-width: 800px)
      flex-direction: column-reverse
      align-items: center
      height: 100%
    iframe
      min-height: 450px

  &__two
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 40px
    @media (max-width: 800px)
      margin-top: 20px
    > iframe
      min-height: 584px
      @media (max-width: 800px)
        min-height: 640px
    
.layout-idp
  max-width: 1280px

  @media (max-width: 800px)
    padding: 0 16px

.container-idp
  width: 51%
  display: flex

  @media (max-width: 800px)
    width: 100%
    justify-content: center

.container-sso
  width: 49%
  display: flex

  @media (max-width: 800px)
    width: 100%

.idp-content
  width: 100%
  padding: 122px 0 0 0

  @media (max-width: 800px)
    width: 480px
    padding: 0

  @media (max-width: 512px)
    width: 100%
    padding: 0 16px

.sso-content
  padding-left: 60px
  margin-top: 30px

  @media (max-width: 800px)
    width: 100%
    padding-left: 0
    margin-top: 20px
    margin-bottom: 40px
</style>